import { render } from "./KioskView.vue?vue&type=template&id=0c5d3c0b"
import script from "./KioskView.vue?vue&type=script&lang=js"
export * from "./KioskView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__